/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { computed, reactive, Ref, watch } from '@vue/composition-api'

export function useUpdater<T>(modelRef: Ref<T>, keys: string[]) {
  const initial: any = keys.reduce((prev, key) => {
    return {
      ...prev,
      [key]: undefined
    }
  }, {})

  const updateBag: any = reactive(initial)

  // eslint-disable-next-line
  const modelProps: any = keys.reduce((prev, key) => {
    const val = computed({
      get() {
        return typeof updateBag[key] !== 'undefined'
          ? updateBag[key]
          : // eslint-disable-next-line
            modelRef.value && (modelRef.value as any)[key]
      },
      set(val) {
        updateBag[key] = val
      }
    })
    return {
      ...prev,
      [key]: val
    }
  }, {})

  let stopWatcher: () => void
  const onChange = (callback: (isEqual: boolean) => void) => {
    stopWatcher && stopWatcher()
    stopWatcher = watch(
      () => updateBag,
      bag => {
        const isEqual = Object.keys(bag).every(
          k =>
            typeof bag[k] === 'undefined' ||
            bag[k] === (modelRef.value as any)[k]
        )
        callback(isEqual)
      },
      { deep: true }
    )
  }

  return {
    updateBag,
    modelProps,
    onChange
  }
}
